import { motion } from "framer-motion";
import { MANIFESTO } from "@/data/content";

export default function Manifesto() {
  return (
    <section
      id="manifesto"
      className="relative overflow-hidden bg-[#050505] px-5 sm:px-8 lg:px-12 py-24 sm:py-36"
      data-testid="manifesto"
    >
      <div className="pointer-events-none absolute inset-0 spotlight-top opacity-60" />
      <div className="relative mx-auto max-w-6xl">
        <span className="mb-20 flex items-center gap-3 text-[11px] font-bold uppercase tracking-[0.3em] text-zinc-500">
          <span className="h-px w-10 bg-zinc-600" />
          The Manifesto
        </span>

        <div className="flex flex-col">
          {MANIFESTO.map((c, i) => (
            <motion.div
              key={c.no}
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
              className={`relative grid grid-cols-1 md:grid-cols-12 items-center gap-6 border-t border-white/10 py-14 ${
                i === MANIFESTO.length - 1 ? "border-b" : ""
              }`}
            >
              <div className="md:col-span-5 relative">
                <span className="font-display text-[22vw] md:text-[13vw] font-extrabold leading-none text-white/[0.06] select-none">
                  {c.no}
                </span>
              </div>
              <div className="md:col-span-7 md:pl-6">
                <h3 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold uppercase tracking-tight text-white">
                  {c.title}
                </h3>
                <p className="mt-6 max-w-xl text-base sm:text-lg font-light leading-relaxed text-zinc-400">
                  {c.body}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
